/**
 * Role code constants matching the seeded roles in the backend.
 * Used for admin override checks and role-based UI gating.
 */
export const SYSTEM_ADMIN_ROLE = 'SYS_ADMIN';
